module.exports = __webpack_public_path__ + "img/_Zeus.1b8e9c49.png";